// src/components/StatusBadge.jsx — Light Theme
import React from "react";

const STATUS_CONFIG_LIGHT = {
  Pending:   { color:"#b45309", bg:"#fff7ed", border:"#fed7aa", label:"Pending"   },
  Completed: { color:"#15803d", bg:"#f0fdf4", border:"#bbf7d0", label:"Completed" },
  'No Response':    { color:"#b91c1c", bg:"#fef2f2", border:"#fecaca", label:"No Response"    },
  Upcoming:  { color:"#1d4ed8", bg:"#eff6ff", border:"#bfdbfe", label:"Upcoming"  },
};

export default function StatusBadge({ status, size = "default", showDot = true }) {
  const config = STATUS_CONFIG_LIGHT[status] || {
    color:"#4a6580", bg:"#f5f8fc", border:"#dce6f0", label: status || "Unknown",
  };

  const sizeMap = {
    small:   { fontSize:10, padding:"2px 7px",  dotSize:5 },
    default: { fontSize:11, padding:"3px 10px", dotSize:6 },
    large:   { fontSize:12, padding:"5px 14px", dotSize:7 },
  };
  const sz = sizeMap[size] || sizeMap.default;

  return (
    <span style={{
      display:"inline-flex", alignItems:"center", gap:5,
      padding:sz.padding, borderRadius:20,
      background:config.bg, border:`1px solid ${config.border}`,
      color:config.color, fontSize:sz.fontSize,
      fontWeight:600, fontFamily:"Inter, sans-serif",
      letterSpacing:"0.3px", whiteSpace:"nowrap", lineHeight:1.4,
    }}>
      {showDot && (
        <span style={{
          display:"inline-block", width:sz.dotSize, height:sz.dotSize,
          borderRadius:"50%", background:config.color, flexShrink:0,
          animation: status==="Pending" ? "badgePulse 1.8s infinite" : "none",
        }} />
      )}
      {config.label}
      <style>{`
        @keyframes badgePulse {
          0%,100%{opacity:1;transform:scale(1)}
          50%{opacity:0.35;transform:scale(0.65)}
        }
      `}</style>
    </span>
  );
}